import { LOAN_ACTION_ARITHMETIC_OPERATIONS_ACTION_TYPE } from '../actions/loanActionArithmeticOperations.actions';

const initialState = {};

const loanActionArithmeticOperationsSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ACTION_ARITHMETIC_OPERATIONS_ACTION_TYPE.GET_LOAN_ACTION_ARITHMETIC_OPERATIONS_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default loanActionArithmeticOperationsSchemaReducer;
